import { AppBar, Button, colors, Hidden, IconButton, Toolbar } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import InputIcon from '@mui/icons-material/Input';
import MenuIcon from '@mui/icons-material/Menu';
import { makeStyles } from '@mui/styles';
//import SearchIcon from '@mui/icons-material/Search';
import KSLogo from 'assets/img/Keepspace-logo-200-inverted.png';
import clsx from 'clsx';
import { PricingModal } from 'components';
import ProfilePopover from 'components/Popover/ProfilePopover';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutAdmin } from '../../../../actions/admin/authenticationActions';
import ResponsiveHidden from '../../../../components/ResponsiveHidden';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    // backgroundColor: theme.palette.primary.main
    backgroundColor: '#40B5AD',
  },
  flexGrow: {
    flexGrow: 50,
  },
  logo: {
    height: 24,
  },
  search: {
    backgroundColor: 'rgba(255,255,255, 0.1)',
    borderRadius: 4,
    flexBasis: 300,
    height: 36,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: 'inherit',
  },
  searchInput: {
    flexGrow: 1,
    color: 'inherit',
    '& input::placeholder': {
      opacity: 1,
      color: 'inherit',
    },
  },
  searchPopper: {
    zIndex: theme.zIndex.appBar + 100,
  },
  searchPopperContent: {
    marginTop: theme.spacing(1),
  },
  trialButton: {
    marginLeft: theme.spacing(2),
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900],
    },
  },
  trialIcon: {
    marginRight: theme.spacing(1),
  },
  iconButton: {
    marginLeft: theme.spacing(1),
  },
  notificationsBadge: {
    backgroundColor: colors.orange[600],
  },
  logoutButton: {
    marginLeft: theme.spacing(1),
  },
  logoutIcon: {
    marginRight: theme.spacing(1),
  },
  avatar: {
    marginLeft: theme.spacing(1),
  },
  // TopWidth: {
  //   width: '440vW'
  // }
  sidebarToggler:{
    marginLeft: '10px !important',
  },


}));

const TopBar = props => {
  const { onOpenNavBarMobile, setShowDesktopSidebar, className, ...rest } = props;

  const session = useSelector(state => state.adminAuthReducer.currentAdmin);

  const id = session.id;
  const classes = useStyles();
  // const searchRef = useRef(null);
  const dispatch = useDispatch();

  const notificationsRef = useRef(null);
  const profileRef = useRef(null);
  const [pricingModalOpen, setPricingModalOpen] = useState(false);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);


  const handleLogout = async () => {
    localStorage.setItem('logout', Date.now().toString());
    await dispatch(logoutAdmin(id));
  };


  useEffect(() => {
    // Add an event listener to handle the storage event
    const handleStorage = async (event) => {
      if (event.key === 'logout') {
        localStorage.removeItem('logout');
      } else if (event.key === '_ADMIN') {
        window.location.reload();
      }
    };
    window.addEventListener('storage', handleStorage, false);

    return () => {
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  const handlePricingClose = () => {
    setPricingModalOpen(false);
  };

  const handleNotificationsClose = () =>
    setOpenNotifications(false);


  const handleProfileClose = () =>
    setOpenProfile(false);

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color='primary'  // set in makestyles
    >
      <Toolbar>
        {/* <RouterLink to="/"> */}
        <a href='/admin'>
          <img className={classes.logo}
               alt='Logo'
               src={KSLogo}
          />
        </a>
        <Hidden smDown={true}>
          <IconButton
            className={classes.sidebarToggler}
            color='inherit'
            onClick={()=>setShowDesktopSidebar(prev => !prev)}
          >
            <MenuIcon/>
          </IconButton>
        </Hidden>
        <div className={classes.flexGrow}/>
        {/* <div className={classes.TopWidth}> */}

        <Button
          className={classes.logoutButton}
          color='inherit'
          onClick={handleLogout}
        >
          <InputIcon className={classes.logoutIcon}/>
        </Button>

        <div className={classes.avatar}>
          <Avatar alt='Admin' src={session.id ? require(`assets/img/avatars/00${session.id % 46 + 1}.svg`) : null}/>
        </div>

        <ResponsiveHidden mdUp>
          <IconButton color='inherit' onClick={onOpenNavBarMobile} size="large">
            <MenuIcon/>
          </IconButton>
        </ResponsiveHidden>

      </Toolbar>
      <PricingModal
        onClose={handlePricingClose}
        open={pricingModalOpen}
      />
      <ProfilePopover
        anchorEl={profileRef.current}
        notifications={[]}
        onClose={handleProfileClose}
        open={openProfile}
      />
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func,
};

export default TopBar;
